// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__00wu3","loader__svg":"loader_loader__svg__BV3m5","rotate":"loader_rotate__cAw4o"};